'use client';
import { styled } from '@mui/material/styles';
import MuiStack, { StackProps } from '@mui/material/Stack';

const StyledStack = styled(MuiStack)<StackProps>({});

export const Stack = (props: StackProps) => <StyledStack {...props} />;
